import {addModalWindow, addToast} from "../ducks/duck-screen";
import {errorModal} from "../helpers/modal-builder";
import StackTrace from 'stacktrace-js'
import {getTranslation} from "../helpers/get-translation";

const VERSION = getTranslation("analytics_app_version");

export const LOG_ERROR = "LOG_ERROR";
export const NON_FATAL_ERROR = "NON_FATAL_ERROR";
export const CRASH_ERROR = "CRASH_ERROR";
export const CRASH_CLOUD_FUNCTION_ERROR = "CRASH_CLOUD_FUNCTION_ERROR";

export function sendError(error, errorLevel, code, inputParameters) {
	if(isErrorLevelCorrect(errorLevel)){

		addParametersToErrorIfNotPresent(error, code, inputParameters);
		return {
			type: errorLevel,
			payload: {
				error
			}
		}
	} else {
		throw Error(`unknown error level ${errorLevel}`)
	}
}

function isErrorLevelCorrect(errorLevel) {
	return errorLevel === LOG_ERROR ||
		errorLevel === NON_FATAL_ERROR ||
		errorLevel === CRASH_ERROR ||
		errorLevel === CRASH_CLOUD_FUNCTION_ERROR;
}

export function isErrorFromCloudFunction(error){
	return error.details && error.message.indexOf("!-!") >= 0
}

export function parseCloudFunctionErrorAndUnsetCode(error){
	const splitted = error.message.split("!-!");
	error.message = splitted[0];
	error.code = "";
	debugger;
	return splitted[1]
}

export function addReducerParametersToError(error, code, action, state){
	const actionString = "Action: " + JSON.stringify(action);
	const stateString = "State: " + JSON.stringify(state);
	addParametersToErrorIfNotPresent(error, code, actionString + " | " + stateString)
}

export function addParametersToErrorIfNotPresent(error, code, inputParameters){
	if(!error.code){
		error.code = code;
	}
	if(!error.inputParameters){
		error.inputParameters = inputParameters;
	}
}

function isErrorBecauseOffline(error) {
	return error.code === "unavailable" //Offline
}

export default store => next => action => {
	try {
		switch (action.type) {
			case LOG_ERROR:{
				const error = action.payload.error;
				console.error("LOG", error);
				break;
			}
			case NON_FATAL_ERROR:{
				debugger;
				const error = action.payload.error;
				console.error("FATAL", error);
				const code = error.code || "error_generic";
				store.dispatch(addToast(code));
				tryToGetStackTraceAndSendEvent("Non-fatal", error);
				break;
			}
			case CRASH_ERROR:{
				debugger;
				const error = action.payload.error;
				if(isErrorBecauseOffline(error)){
					store.dispatch(addToast("error_offline"));
					break
				}
				console.error("CRASH", error);
				const code = error.code || "error_generic";
				const modal = errorModal(code);
				store.dispatch(addModalWindow(modal));

				tryToGetStackTraceAndSendEvent("Crash", error);

				break;
			}
			case CRASH_CLOUD_FUNCTION_ERROR:{
				const error = action.payload.error;
				debugger;

				console.error("CRASH_CLOUD_FUNCTION", error);
				const code = error.code || "error_generic";
				const modal = errorModal(code);
				store.dispatch(addModalWindow(modal));
				sendGtagEvent("Crash Cloud Function", error, error.details)

				break;
			}
			default:
				return next(action);
		}
	} catch (error) {
		console.error('Caught an exception!', error);

		const modal = errorModal('error_generic');
		store.dispatch(addModalWindow(modal));

		tryToGetStackTraceAndSendEvent("Crash", error);
		// throw error
	}
}

window.onerror = function(message, source, lineno, colno, error){
	console.error(error)
	debugger
	tryToGetStackTraceAndSendEvent("Crash Browser on-error", error)
}

function tryToGetStackTraceAndSendEvent(type, error) {
	StackTrace.fromError(error)
		.then(stackTrace => {
			console.log(stackTrace);
			debugger;
			sendGtagEvent(type, error, stackTrace.toString())
		})
		.catch(error => {
			sendGtagEvent(type, error)
		});
}

export function sendGtagEvent(type, error, stackTrace = ""){
	const action = `${type} ${VERSION}`;
	let category = error.toString() + " at " +  (stackTrace || error.stack);
	debugger;
	if(error.code){
		category = error.code + " | " + category
	}
	let inputParameters = error.inputParameters || "";
	window.gtag('event', action, {'event_category': category, 'event_label': inputParameters});
}
